
<div>
  <Layout />
  <CookieConsent />
</div>
